import FormsActionTypes from 'redux/forms/types';

function mapTiedApplication(applicationForms, forms) {
  let tiedApplication = [];
  if (applicationForms && applicationForms.length !== 0) {
    forms.content.forEach((form) => {
      applicationForms.forEach((application) => {
        if (form.id === application.formId) {
          tiedApplication.push(application.title);
        }
      });
      if (tiedApplication.length > 0) {
        form.tiedApplications = tiedApplication;
        tiedApplication = [];
      }
    });
  }
  return forms;
}

const initialState = {
  forms: {
    content: null,
  },
  singleForm: {},
  applicationForms: null,
  filterOn: false,
  loading: undefined,
  error: undefined,
  saving: false,
  errorSaving: false,
};

function formsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case FormsActionTypes.SEARCH_FORMS:
      return {
        ...state,
        loading: true,
      };
    case FormsActionTypes.SEARCH_FORMS_BY_STATUS:
      return {
        ...state,
        loading: true,
      };
    case FormsActionTypes.SEARCH_FORMS_RESULTS:
      const resultData = mapTiedApplication(state.applicationForms, payload);
      return {
        ...state,
        forms: resultData,
        loading: false,
        filterOn: true,
      };
    case FormsActionTypes.START_CREATE_FORM:
      return {
        ...state,
        saving: true,
        errorSaving: false,
      };
    case FormsActionTypes.CREATE_FORM_SUCCESS:
      return {
        ...state,
        forms: { ...state.forms, content: [payload, ...state.forms.content] },
        saving: false,
        errorSaving: false,
      };
    case FormsActionTypes.CREATE_FORM_FAILURE:
      return {
        ...state,
        saving: false,
        errorSaving: true,
      };
    case FormsActionTypes.START_FETCH_FORMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FormsActionTypes.FETCH_FORMS_SUCCESS:
      const formData = mapTiedApplication(state.applicationForms, payload);
      return {
        ...state,
        loading: false,
        forms: formData,
        filterOn: false,
      };
    case FormsActionTypes.FETCH_FORMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case FormsActionTypes.DELETE_FORMS_SUCCESS:
      return {
        ...state,
        forms: {
          ...state.forms,
          content: state.forms.content.filter((form) => form.id !== payload),
        },
      };
    case FormsActionTypes.DEACTIVATE_FORM_SUCCESS:
      return {
        ...state,
        forms: {
          ...state.forms,
          content: state.forms.content.map((form) =>
            form.id === payload.id ? payload : form
          ),
        },
      };
    case FormsActionTypes.START_FETCH_APPLICATIONS_FORMS:
      return {
        ...state,
      };
    case FormsActionTypes.FETCH_APPLICATIONS_FORMS_SUCCESS:
      return {
        ...state,
        applicationForms: payload,
      };
    case FormsActionTypes.FETCH_APPLICATIONS_FORMS_FAILURE:
      return {
        ...state,
        error: payload,
      };
    case FormsActionTypes.FETCH_SINGLE_FORM_SUCCESS:
      return {
        ...state,
        singleForm: payload,
      };
    case FormsActionTypes.FETCH_SINGLE_FORM_FAILURE:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
}

export default formsReducer;
